<template>
  <!--  DEACTIVATE USER    -->
  <div>
    <div class="text-center">
      <button v-b-modal.modal-user-deactivate
              class="btn btn-outline-danger btn-rounded"
              type="button"> Deactivate Account
        <i class="fas fa-user-lock"></i>
      </button>
    </div>

    <b-modal id="modal-user-deactivate"
        cancel-variant="info" ok-title="Deactivate" ok-variant="danger"
        :title="`Deactivate ${user.first_name} ${user.last_name}'s Account?`" @ok="deactivateAccount"
    >
      <p>
        Are you sure you want to deactivate your account?
        <i class="far fa-sad-tear menu_icon"></i>
        You can always reactivate by <em>Signing Up</em> again!
      </p>
    </b-modal>
  </div>
</template>

<script>
import {
  handleError,
  redirectAfterCountDown,
  secureStoreDeleteUserInfo,
  secureStoreGetAuthString,
  showFlashMessage,
  startLoader
} from "@/utils/util_functions";
import axios from "axios";
import {user_resource} from "@/utils/api_paths";

export default {
  name: "DeactivateUser",

  props: {
    user: {
      required: true
    }
  },

  methods: {
    deactivateAccount() {
      let loader = startLoader(this)
      axios.delete(user_resource, {
        headers:
            {
              Authorization: secureStoreGetAuthString(),
              deactivate: true,
              email: this.user.email
            }
      }).then((response) => {
        // redirect after successful signUp
        if (response.status === 200) {
          setTimeout(() => {
            secureStoreDeleteUserInfo()
            loader.hide()
            showFlashMessage(this, 'success', 'Account Deactivated', 'Your account has been successfully deactivated.' +
                '\nSorry to see you go.');
            +redirectAfterCountDown(this, '/home')
          }, 2500)
        }
      }).catch((error) => {
        handleError(this, error, loader)
      })
    },
  }
}
</script>
